<template>
    <div class="box-consent">
        <div class="bg-checkbox" :class="{'active': isAcceptTerm}" @click="checkTerm()">
            <!-- <img @click="toggleCheckBoxTerm()" v-show="!isAcceptTerms" src="@/assets/icon/regis_iconcheck_inactive@2x.png">
            <img @click="toggleCheckBoxTerm()" v-show="isAcceptTerms" src="@/assets/icon/regis_iconcheck_active@2x.png"> -->
        </div>
        <div class="text">
            <div>
                {{lbl.register.terms.i_agree}} <span class="span-underline" @click="clickToPrivacy('privacy')">{{lbl.register.terms.link_terms}}</span>
                <span> {{lbl.register.terms.and}} <span class="span-underline" @click="clickToTerm('terms')">{{lbl.register.terms.link_condition}}</span> </span>
            </div>
        </div>
        <div class="bg-checkbox" :class="{'active': isAcceptNews}" @click="checkNews()">
        </div>
        <div class="text">
            <div>
                {{lbl.register.terms.i_agree}} <span class="span-underline" @click="clickToMarketing()">{{lbl.register.consent.link_marketing}}</span>
            </div>
        </div>
        <div class="bg-checkbox" :class="{'active': isAcceptAge}">
        </div>
        <div class="text">
            <div>
                {{lbl.register.consent.age}}
            </div>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//mixin
// import LocaleMixin from "@/mixin/LocaleMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";

export default {
    name: 'BoxConsent',
    props: {
        lbl: Object,
        marketingRegister: Boolean
        // modalController: Object,
    },
    components: {

    },
    mixins: [ModalMixin],
    data: function() {
        return {
            isAcceptTerm: false,
            isAcceptNews: false,
            isAcceptAge: false,
            marketing: {
                all: false,
                email: false,
                sms: false,
                line: false,
                noti: false,
            },
            isTerms: false,
            isPrivacy: false
        };
    },
    created: function () {
        this.initialOtherModal();
    },
    watch: {
        isAcceptTerm: function() {
            if (!this.isAcceptTerm) {
                this.isTerms = false;
                this.isPrivacy = false;
            }
            this.onValidateForm();
        },
        marketingRegister: function() {
            if (this.marketingRegister) {
                this.isAcceptNews = true;
            }
        }
    },
    methods: {
        checkTerm: function () {
            this.isAcceptTerm = !this.isAcceptTerm;
            this.onValidateForm();
        },
        checkNews: function () {
            this.isAcceptNews = !this.isAcceptNews;

            if(this.isAcceptNews){
                this.marketing = {
                    all: true,
                    email: true,
                    sms: true,
                    line: true,
                    noti: false,
                }
            }else{
                this.marketing = {
                    all: false,
                    email: false,
                    sms: false,
                    line: false,
                    noti: false,
                }
            }
            this.$emit('marketing',this.marketing);
            this.$emit('acceptNews',this.isAcceptNews);
            this.marketingModal.setMarketing(this.marketing);
        },
        checkAge: function (isAcceptAge) {
            this.isAcceptAge = isAcceptAge;
            this.onValidateForm();
        },
        clickToTerm: function(type){
            console.log(type);
            this.termsRegisterModal.clearText().setType(type).show();
            this.termsRegisterModal.onClickOk((data) =>{
                this.isTerms = data;
                this.checkConsent();
            });
        },
        clickToPrivacy: function(type){
            this.privacyRegisterModal.clearText().setType(type).show();
            this.privacyRegisterModal.onClickOk((data) =>{
                this.isPrivacy = data;
                this.checkConsent();
            });
        },
        checkConsent: function() {
            if (this.isTerms && this.isPrivacy) {
                this.isAcceptTerm = true;
            }
            return false;
        },
        clickToMarketing: function(){
            this.marketingModal.clearText().setTag('box-consent').show();
            this.marketingModal.onClickOk((data) =>{
                if(data){
                    this.isAcceptNews = true;
                }else{
                    this.isAcceptNews = false;
                }
                this.$emit('acceptNews',this.isAcceptNews);
                this.$emit('marketing', data);
            });
        },
        onValidateForm: function () {
            let isValid = false;

            if(this.isAcceptTerm && this.isAcceptAge){
                isValid = true;
            }
            this.$emit('onValidateForm', isValid);

        },
    },
}
</script>
<style lang='scss' scoped>
@import "@/style/base/base.scss";
@import "@/style/base/baseDisplay.scss";
@import '@/style/input/BaseButton.scss';
.box-consent {
    @extend %display-flex;
    justify-content: space-between;
    margin: {
        top: 30px;
        left: 5px;
    }
    .bg-checkbox {
        background-image: url('../../../assets/icon/regis_iconcheck_inactive@2x.png');
        background-position: center center;
        background-repeat: no-repeat;
        background-size: 100%;
        flex: 0 0 24px;
        width: 24px;
        margin-bottom: 20px;
        img {
            width: 24px;
        }

        &.active {
            background-image: url('../../../assets/icon/regis_iconcheck_active@2x.png');
        }
    }
    .text{
        flex: 0 0 calc(100% - 35px);
        width: calc(100% - 35px);
        margin-bottom: 20px;
        .span-underline{
            color: $pink;
            text-decoration: underline;
        }
    }
}
</style>
